import styled from 'styled-components';

export const PaddedContainer = styled.div`
    ${({ theme }) => `
        padding-right: ${theme.spacing(2)}px;
    `}
`;
